module.exports = __webpack_public_path__ + "static/media/templateHelper.32a6efc2.jpeg";